// console.log('header.js')
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.header__inline-menu');
    this.header_main = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.navDrawer = this.header_main.querySelector("details");
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    document.querySelector(".for-navigation--drawer").addEventListener("click", this.closeNavigationDrawer.bind(this), false);
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    var mainheight = this.offsetHeight,
        navHeight = document.querySelector(".header__inline-menu").offsetHeight,
        totalHeight = mainheight - navHeight,
        scrollOffset = totalHeight,
        headerAndAnnouncement = document.querySelector("#shopify-section-announcement-bar").offsetHeight + navHeight ;

    if(window.outerWidth < 1024){
      scrollOffset = this.currentScrollTop
    }


    if(scrollTop > scrollOffset){
      document.body.classList.add("header--sticky");
      requestAnimationFrame(this.hide.bind(this));
    }
    if(scrollTop <= headerAndAnnouncement){
      document.body.classList.remove("header--sticky");
      requestAnimationFrame(this.reveal.bind(this));
    }


    /*if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }*/

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if(window.outerWidth > 1024){
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }else{
      this.header_main.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if(window.outerWidth > 1024){
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }else{
      this.header_main.classList.add('shopify-section-header-sticky', 'animate');
      this.header_main.classList.remove('shopify-section-header-hidden');
    }
  }

  reset() {
    if(window.outerWidth > 1024){
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }else{
      this.header_main.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  closeMenuDisclosure() {
//     console.log(this.header_main)
    this.disclosures = this.disclosures || this.header_main.querySelectorAll('details-disclosure') || this.navDrawer ;

    if(window.outerWidth > 1024){
      this.disclosures.forEach(disclosure =>disclosure.close());
    }
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header_main.querySelector('details-modal');
    if(window.outerWidth > 1024){
      this.searchModal.close(false);
    }
  }
  
  closeNavigationDrawer(){
    this.closure = this.navDrawer.querySelector("summary");
    this.closure.click();
    
   

  }
  
  


}

customElements.define('sticky-header', StickyHeader);